import axios from 'axios'



const whatsappApiClient = axios.create({
  baseURL: process.env.MIX_SOCKET_API_URL,

  headers: {
    'content-type': 'application/json',
    'accept': 'application/json',
    'apikey': process.env.MIX_SOCKET_API_KEY,
  }
})


function commonExceptions(statusCode) {
  switch (statusCode) {
  case 401:
    throw new Error('Não autorizado, cheque sua chave de acesso.')

  case 404:
    throw new Error('Endpoint da API não localizado.')

  case 500:
    throw new Error('Erro interno no servidor, tente novamente mais tarde')

  default:
    throw new Error('Ocorreu um erro na conexão')
  }
}

function getSessionConfigured() {
  const whatsappSession = process.env.MIX_WHATSAPP_SESSION

  if (!whatsappSession)
    throw new Error(`Sessão não foi encontrada`)

  return whatsappSession
}

export async function getWhatsappSessionUuid() {
  try {
    const sessionName = getSessionConfigured()
    const response = await whatsappApiClient.get(`/instance/fetchInstances?instanceName=${sessionName}`)

    // Support both array format (older API) and object format (v1.8.2+)
    const instance = Array.isArray(response.data) ? response.data[0] : response.data.instance

    if (!instance)
      throw new Error('Nenhuma sessão encontrada')

    // Normalize response to expected format
    return {
      id: instance.instanceId,
      name: instance.profileName || instance.instanceName,
      connectionStatus: instance.status === 'open' ? 'open' : instance.status,
      ...instance
    }
  }

  catch (error) {
    if (error.response)
      commonExceptions(error.response.status)

    throw error
  }

}



export async function disconnectWhatsappSession() {
  try {
    const sessionName = getSessionConfigured()
    const response = await whatsappApiClient.delete(`/instance/logout/${sessionName}`)
    return response.data
  }

  catch (error) {
    if (error.response)
      commonExceptions(error.response.status)

    throw new Error('Error ao fazer conexão')
  }
}

export async function getWhatsappQrCode(sessionName) {
  try {
    const response = await whatsappApiClient.get(`/instance/connect/${sessionName}`)
    return response.data
  }

  catch (error) {
    if (error.response)
      commonExceptions(error.response.status)

    throw new Error('Error ao fazer conexão')
  }
}

export async function getWhatsappGroups(sessionName) {
  try {
    const response = await whatsappApiClient.get(`/group/fetchAllGroups/${sessionName}`, {
      params: {
        getParticipants: false
      }
    })
    return response.data
  }

  catch (error) {
    if (error.response)
      commonExceptions(error.response.status)

    throw new Error('Error ao fazer conexão')
  }
}


export async function startWhatsappSession(sessionName) {
  try {
    const response = await whatsappApiClient.post(`/instance/restart/${sessionName}`, {})
    return response.data
  }

  catch (error) {
    if (error.response)
      commonExceptions(error.response.status)

    throw new Error('Error ao fazer conexão')
  }
}
